"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Super/SuperTableTR.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _store = require('web/store');

const clickDelay = 200






const SuperTableTR = ({ to, children, ...props }) => {
  const mouseDownTime = _react.useRef(undefined)

  const onMouseDown = _react.useCallback.call(void 0, () => {
    mouseDownTime.current = Date.now()
  }, [])

  const onMouseUp = _react.useCallback.call(void 0, () => {
    if (!to) return

    // `undefined` compares false, as NaN did in the class.
    if (mouseDownTime.current !== undefined && Date.now() - mouseDownTime.current < clickDelay) {
      _store.history.push(to)
    }
  }, [to])

  return (
    _react2.default.createElement('tr', { onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        ...props, __self: this, __source: {fileName: _jsxFileName, lineNumber: 28}}
      , children
    )
  )
}

exports. default = SuperTableTR
